<template>
  <input
      type="text"
      name="search-phrase"
      v-model="searchPhrase"
      class="content-search__input"
      v-on:keyup="findContent()"
      placeholder="Vyhľadávanie..."
  />
</template>

<script setup>
  import { ref } from 'vue';
  const searchPhrase = ref('')
  const content = ref(null)

  async function findContent() {

    if (searchPhrase.value.length < 3) {
      content.value = null
      return;
    }

    const param = new URLSearchParams({
      'searchPhrase': searchPhrase.value
    });

    await fetch("/retro-recipe-search/elastic-content-search?" + param)
        .then( response => response.json()
        )
        .then(data => {
              data.forEach(command => {
                const element = document.getElementById(command.selector)

                if (element) {
                  element.innerHTML = '<div></div>'
                  element.innerHTML = command.data;
                }

              })
            })
        .catch((error) => console.error(error));

  }
</script>
